const config = require("./config.global");

config.env = "test";
config.hostname = "test.loola.tv";

// config.mongo.db = 'example_test';

module.exports = config;
